import { loadSentry } from '../../lib/funnels/functions/v1/default/loadSentry'

// @ts-ignore
const env = import.meta.env
const VITE_SENTRY_DSN = env.VITE_SENTRY_DSN || ''

window.addEventListener('load', () => {
  loadSentry(VITE_SENTRY_DSN)
  //@ts-ignore
  window.dataLayer = window.dataLayer || []
  function gtag() {
    //@ts-ignore
    window.dataLayer.push(arguments)
  }
  gtag('js', new Date())

  gtag('config', 'G-NNZDGGCMMK')
})
